import { render, staticRenderFns } from "./Insp.vue?vue&type=template&id=ce5b9090&scoped=true&"
import script from "./Insp.vue?vue&type=script&lang=js&"
export * from "./Insp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5b9090",
  null
  
)

export default component.exports